import React, { Component } from 'react';
import VASSlider from 'react-surveyjs-vas-widget';
// import { Survey, CustomWidgetCollection } from 'survey-react';
import * as Survey from "survey-react";
import   SideNav from "./../../component/sidenav/sidenav.js"
import  Moble from "./../../component/sidenav/moble.js"
import _  from 'underscore';
import "survey-react/survey.css";
import  AuthService  from "../api/authentication.js";
import Image from 'react-image-resizer';
import "./product.css"
import axios from 'axios';
const BASE_URL = 'http://localhost:5000/';


// import { Thumbs } from 'react-responsive-carousel';

 
 const Auth = new AuthService();
class  Product extends Component {


  constructor(props){
    super(props)
    this.state = {
        noerorrpage:true,
        showAdd:false,
        count : 0,
        disabled : false,
        images: [],
        imageUrls : [],
        message: '',
        products:[],
        domain: 'https://uvune-listing.herokuapp.com',  
         domainLOCAL: ' http://localhost:3030',  
        loanData : true,
        items: [],
        visible: 2,
        error: false,
        total:0,
        count:1,
        result:[],
        stopgetMore:true,
        limit:0
     }
     
    
    }

  
      



        
componentDidMount(){
    this.props.noerorrpage(this.state.noerorrpage)
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
      //  body: JSON.stringify(data),
  };
//   fetch(this.state.domain+"/users/"+ Auth.getProfile().userId, requestOptions)
// .then(result1 => result1.json())
//   .then((result1)=>{
//     console.log("error state users==----===----> ", result1 )
//   })
 
fetch(this.state.domain+"/users/"+ Auth.getProfile().userId, requestOptions)
.then(result => result.json())
.then((result)=>{
    this.setState({
      result : result
    })
  // console.log("error state users==----===----> ",  )
    if(result){
      fetch(this.state.domain+"/products?$limit=9&company_id="+result.company_id, requestOptions )
      .then(res => res.json())
      .then(res => {
            //  console.log("product==----===----> ", res )
            if(res.total === res.data.length){
                // console.log("yes", res.total, res.data.length)
                this.setState({
                  stopgetMore : false
                })
            }else{
              // console.log("no", res.total, res.data.length)
              this.setState({
                stopgetMore : true
              })
            }
              this.setState({
                details: res.quick_details,
                loanData : false,
                products:res.data,
                total:res.total,
                limit :res.limit
              })  
        })
    }
  })  
}


Addmore=(e)=>{
  e.preventDefault()
  this.setState({
    loanData:true
  });

    
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
        //  body: JSON.stringify(data),
       };
      
        var checktotal =  this.state.total -  this.state.products.length 
        // console.log("checkdata ===---->",checktotal)
          if( checktotal <= 9 ){
            var totar = this.state.limit + 0
            // console.log("data limit--==--->",  this.state.limit + 9 )
            fetch(this.state.domain+"/products?$limit=9&company_id="+this.state.result.company_id+"&$skip="+ totar , requestOptions )
            .then(res => res.json())
            .then(res => {
            
                 
              let product =  this.state.products
                  res.data.forEach( (data, index) => {
                    product.push(data)
                  })
                this.setState({
                  product:  product,
                  loanData : false,
                   limit :  this.state.limit + 9
                })
              //  console.log("product==----===----> yes", this.state.products, this.state.total )
               if(this.state.products.length === this.state.total){
                // console.log("yes", res.total, this.state.products.length)
                this.setState({
                  stopgetMore : false,
                  loanData:false
                })
                }else{
                  // console.log("no", res.total, this.state.products.length)
                  this.setState({
                    stopgetMore : true,
                    loanData:false
                  })
                }
              //     // this.setState({
              //     //   details: res.quick_details,
              //     //   loanData : false,
              //     //   products:res.data
              //     // })  
          
          })
      }else{
        var totar = this.state.limit + 9
        // console.log("data limit--==--->",  this.state.limit + 9 )
        fetch(this.state.domain+"/products?$limit=9&company_id="+this.state.result.company_id+"&$skip="+ totar , requestOptions )
        .then(res => res.json())
        .then(res => {
          
             
          let product =  this.state.products
              res.data.forEach( (data, index) => {
                product.push(data)
              })
            this.setState({
              product:  product,
              loanData : false,
               limit :  this.state.limit + 9
            })
          //  console.log("product no==----===----> ", this.state.products, this.state.total )
           if(this.state.products.length === this.state.total){
            // console.log("yes", res.total, this.state.products.length)
            this.setState({
              stopgetMore : false,
              loanData:false
            })
        }else{
          // console.log("no", res.total, this.state.products.length)
          this.setState({
            stopgetMore : true,
            loanData:false
          })
        }
          //     // this.setState({
          //     //   details: res.quick_details,
          //     //   loanData : false,
          //     //   products:res.data
          //     // })  
      
      })
      }
     
}


showInput=(e)=>{
    e.preventDefault()
  this.setState({
    showAdd:true
  })
    // console.log(w)

}




  render() {

    const style = {
      image: {
     
        background: '#fefefe',
        margin:"auto",
        marginTop:"10px"
      }

    }
      //  console.log("data log console", this.props.organizers)
      //  console.log("data log",this.props.organizer, this.state.products)
    
    return (
              <div id="dashboard-wrapper " class="columns dashboard-cousom">
                  {/* <div class="column"></div>
                  <div class="content column is-11"> */}
              
                      {/* <!-- Breadcrumbs --> */}
                        <nav class="breadcrumbs">
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li>All Product</li>
                            </ul>
                        </nav>
                      <br/>

                      {
                        this.state.loanData?
              
                       <div class="pre-loader">
                        <div class="loader"></div>
                      </div> 
                            :
                            <div></div>
                        }
                    

                       <div className="company-product-body">
                                 <div className="company-product-image-click">
                                     <a class="button is-success is-small " href="/product-new">Add product</a>
                                </div>
                                <div className="company-product-image-head">
                                       All products
                                      
                                 </div>

                                 {/* <div style={{width:"80%",margin:"auto"}}>
                                     <div class="control-material is-secondary has-icon">    
                                            <input class="material-input" type="text" required=""/>
                                            <i class="material-icons">search</i>
                                            <span class="material-highlight"></span>
                                            <span class="bar"></span>
                                           
                                        </div>

                                 </div> */}
                                 
                                 <br/>
                         {
                           this.state.products?
                              <div>
                               {
                                      this.state.products.length === 0 ?
                                    <div>
                                       <div className="product-empty-body"> 
                                                    <p> No product</p>
                                                <i className="sl sl-icon-social-dropbox"></i>
                                               <br/>
                                          <a class="button is-success is-small " href="/product-new">Add product</a>
                          
                                      </div>
                                    </div>
                                  :
                                    <div className="company-product-image-body">

                                  <ul className="product-content-image-li">
                                      {
                                          this.state.products.map((product, i)=>{
                                                return(
                                                  <li key={i}>
                                                     <div class="card card-floating-boxed card-shadow">
                                                    <div class="card-image">
                                                      <br/>
                                                      {
                                                         product.product_images_url ?
                                                         <div style={{height:"220px",width:"80%",margin:"auto",marginTop:"10px",marginBottom:"30px"}}>
                                                            {

                                                                product.product_images_url.length === 0?
                                                                  <img   src="https://res.cloudinary.com/easywaya/image/upload/v1535530819/uvunelogo2_ayfgrq.png" />
                                                                :
                                                               
                                                                    <Image
                                                                    src={product.product_images_url[0]}
                                                                    width={200}
                                                                    height={200}
                                                                    style={style.image}
                                                                  />
                                                            }
                                                            
                                                          </div>
                                                         :
                                                         <div style={{height:"220px",width:"80%",margin:"auto",marginTop:"10px",marginBottom:"30px"}}>
                                                        
                                                               <img   src="https://res.cloudinary.com/easywaya/image/upload/v1535530819/uvunelogo2_ayfgrq.png" />
                                                             
                                                         
                                                          </div>
                                                      }
                                                    
                                                        
                                                       
                                                    </div>
                                                    <div class="card-content">
                                                        <div class="media">
                                                            <div class="media-content">
                                                                <p class="title is-7 color-accent"> {product.name}</p>
                                                             
                                                            </div>
                                                        </div>
                                                        <div class="has-text-left">
                                                            <a class="button btn-align accent-btn raised" href={'/product/'+product._id}>Read more</a>
                                                        </div>
                                                    </div>
                                                </div>

                                                  </li>
                                                 
                                                 
                                                    ) 
                                                })
                                            }


                                             
                                              
                                    </ul>
                                    
                                    <div className="product-load-more">
                                          {
                                               this.state.stopgetMore ? 
                                               <button class="button is-success" onClick={this.Addmore} style={{width:"50%"}}>Load  More</button>
                                               :
                                               ""
                                           }
                                   

                                    </div>
                                         
                                    
                 
                                    <div>
                    
                                        
                            </div>
                       </div>
                       }
                     </div>
                     :
                     <div>
                      
                     </div>
                    }       
                   </div>         
                </div>
            )
        }
    }    
  export default  Product;      






// WEBPACK FOOTER //
// ./src/component/company/prodcut.js